import React, {useEffect,useRef,useState} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import sectionStyles from './SectionContainer-tw-styles';
import getWidth from '../../../utils/gridWidth';

function SectionContainer(props) {
  const { children, background, styles, ariaLabel, width, domId } = props;
  let sectionStyle = sectionStyles['section-default'];
  if (styles && sectionStyles[styles.trim()] !== undefined) {
    sectionStyle = sectionStyles[styles.trim()];
  }
  let widthClass;
  if (width == null) {
    widthClass = '';
  } else {
    widthClass = getWidth(width);
  }
  
  const isCarouselRegion = styles === 'section-homepage-carousel';
  const regionProps = isCarouselRegion ? {
    role: 'region',
    'aria-roledescription': 'carousel'
    // 'aria-label': 'Carrossel de destaques Pantene'
  } : {};
  
  useEffect(() => {
    function handleMessage(event) {
      if (event.data?.type === 'IFRAME_HEIGHT') {
        document.getElementById('haircode-quiz-iframe').style.height = event.data.height ?`${event.data.height+50}px` : '800px'
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [])

  return (
    <div
      className={classNames(widthClass, sectionStyle.section)}
      style={background}
      id={domId || ''}
    >
      {props.styles=='section-white-30' && props.children.length>3?
      <div className={classNames(sectionStyle.container)}>
        <section 
          className={classNames(sectionStyle.componentWrapper)}
          aria-label={getAriaLabel(props.styles)} role="region"
        >
          <ul>
          {React.Children.map(children, (child, index) => (
            <li key={index}>{child}</li>
          ))} 
          </ul>
        </section>
      </div>
      :<div className={classNames(sectionStyle.container)}>
      <section 
        className={classNames(sectionStyle.componentWrapper)}
        // role={getComponentRole(props.styles)}
        aria-label={isCarouselRegion ? undefined : ariaLabel}
        tabIndex={-1} role="region"
      >
        {children} 
      </section>
    </div>
  }
    </div>
  );
}

SectionContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object]).isRequired,
  styles: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  domId: PropTypes.string,
  background: PropTypes.oneOfType([PropTypes.object]),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const SectionContainer = ({prop = val, styles = '', width = null, domId = '', background = null }) =>

export default SectionContainer;
